import styled from 'styled-components'

export const ComingSoonContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
export const ComingSoonContentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ComingSoonMainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const ComingSoonTitle = styled.h1`
  margin: 0;
  font-family: 'Poppins';
  font-size: 80px;
  color: ${({ theme }) => theme.colors.primary};
`

export const ComingSoonTitleSecondary = styled.h1`
  margin: 0;
  font-family: 'Poppins';
  font-size: 80px;
  color: #00e3d6;
`

export const ComingSoonButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
`
